import React, { useState, useEffect } from 'react';
import './Header.css';

const Header = ({ currentPath = '/' }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeMobileDropdown, setActiveMobileDropdown] = useState(null);
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeTutorsSubMenu, setActiveTutorsSubMenu] = useState(null);

  const [isMobileMaleTutorsOpen, setIsMobileMaleTutorsOpen] = useState(false);
  const [isMobileFemaleTutorsOpen, setIsMobileFemaleTutorsOpen] = useState(false);

  // Add scroll class for premium sticky header effect
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    setActiveMobileDropdown(null); // Reset dropdowns when toggling menu
    setIsMobileMaleTutorsOpen(false);
    setIsMobileFemaleTutorsOpen(false);
  };

  const handleMobileDropdownToggle = (dropdownName) => {
    if (activeMobileDropdown === dropdownName) {
      setActiveMobileDropdown(null);
      setIsMobileMaleTutorsOpen(false);
      setIsMobileFemaleTutorsOpen(false);
    } else {
      setActiveMobileDropdown(dropdownName);
    }
  };

  return (
    <header className={`header ${isScrolled ? 'header--scrolled' : ''}`}>
      <div className="header__wrapper">
        {/* Left Side: Logo */}
        <a href="/" className="header__logo-container" aria-label="Al Quran Lesson">
          <img
            src={`${process.env.PUBLIC_URL}/assets/images/logo.png`}
            alt="Al Quran Lesson"
            className="header__logo-image"
          />
        </a>

        {/* Center: Desktop Navigation */}
        <nav className="header__nav">
          <ul className="header__menu">
            <li className="header__menu-item">
              <a href="/" className={`header__menu-link ${currentPath === '/' ? 'header__menu-link--active' : ''}`}>HOME</a>
            </li>
            <li className="header__menu-item">
              <a href="/about-us/" className={`header__menu-link ${currentPath === '/about-us' ? 'header__menu-link--active' : ''}`}>ABOUT US</a>
            </li>

            {/* Courses Dropdown */}
            <li className="header__menu-item header__menu-item--has-dropdown">
              <span className="header__menu-link">
                COURSES
                <svg className="header__chevron" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
                </svg>
              </span>
              <ul className="header__dropdown">
                <li><a href="/noorani-qaida-course/">Noorani Qaida</a></li>
                <li><a href="/quran-reading-classes-online-for-kids-and-adults/">Quran Reading Classes Online</a></li>
                <li><a href="/online-tajweed-classes-tajweed-course/">Quran Tajweed Classes</a></li>
                <li><a href="/quran-memorization-classes-course/">Quran Memorization Classes</a></li>
                <li><a href="/quran-translation-classes/">Quran Translation Classes Online</a></li>
              </ul>
            </li>

            <li className="header__menu-item">
              <a href="/quran-classes-fee/" className={`header__menu-link ${currentPath === '/quran-classes-fee' ? 'header__menu-link--active' : ''}`}>FEE PACKAGES</a>
            </li>
            <li className="header__menu-item">
              <a href="/blog/" className={`header__menu-link ${currentPath === '/blog' ? 'header__menu-link--active' : ''}`}>BLOG</a>
            </li>

            {/* Locations Dropdown */}
            <li className="header__menu-item header__menu-item--has-dropdown">
              <a href="/locations/" className={`header__menu-link ${currentPath === '/locations' ? 'header__menu-link--active' : ''}`}>
                LOCATIONS
                <svg className="header__chevron" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
                </svg>
              </a>
              <ul className="header__dropdown">
                <li><a href="/online-quran-classes-in-newyork/">Online Quran Classes In NewYork</a></li>
                <li><a href="/online-quran-classes-canada/">Online Quran Classes In Canada</a></li>
                <li><a href="/online-quran-classes-texas/">Online Quran Classes In Texas</a></li>
                <li><a href="/online-quran-classes-california/">Online Quran Classes In California</a></li>
                <li><a href="/florida-online-quran-classes/">Online Quran Classes In Florida</a></li>
              </ul>
            </li>

            {/* Our Tutors Dropdown */}
            <li
              className="header__menu-item header__menu-item--has-dropdown header__menu-item--tutors"
              onMouseLeave={() => setActiveTutorsSubMenu(null)}
            >
              <a href="/our-tutors/" className={`header__menu-link ${currentPath === '/our-tutors' ? 'header__menu-link--active' : ''}`}>
                OUR TUTORS
                <svg className="header__chevron" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
                </svg>
              </a>
              <div className={`header__dropdown header__dropdown--split ${activeTutorsSubMenu ? 'header__dropdown--split-active' : ''}`}>
                <div className="header__dropdown-col-left">
                  <button
                    className={`header__dropdown-btn ${activeTutorsSubMenu === 'male' ? 'header__dropdown-btn--active' : ''}`}
                    onMouseEnter={() => setActiveTutorsSubMenu('male')}
                  >
                    <span>Male Tutors</span>
                    <svg className="header__dropdown-chevron-right" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clipRule="evenodd" />
                    </svg>
                  </button>
                  <button
                    className={`header__dropdown-btn ${activeTutorsSubMenu === 'female' ? 'header__dropdown-btn--active' : ''}`}
                    onMouseEnter={() => setActiveTutorsSubMenu('female')}
                  >
                    <span>Female Tutors</span>
                    <svg className="header__dropdown-chevron-right" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clipRule="evenodd" />
                    </svg>
                  </button>
                </div>
                <div className="header__dropdown-col-right">
                  {activeTutorsSubMenu === 'male' && (
                    <ul className="header__tutors-sublist">
                      <li><a href="/our-tutors/molana-hafiz-kaleem-ullah/">Molana Hafiz Kaleem Ullah</a></li>
                      <li><a href="/our-tutors/molana-hafiz-qari-osama-hussein/">Molana Hafiz Qari Osama Hussein</a></li>
                    </ul>
                  )}
                  {activeTutorsSubMenu === 'female' && (
                    <ul className="header__tutors-sublist">
                      <li><a href="/our-tutors/qaria-sadaf-sarfaraz/">Qaria Sadaf Sarfaraz</a></li>
                      <li><a href="/our-tutors/aalima-qaria-yousra/">Aalima Qaria Yousra</a></li>
                    </ul>
                  )}
                </div>
              </div>
            </li>
          </ul>
        </nav>

        {/* Right Side: CTA Button */}
        <div className="header__cta">
          <a href="/free-trial/" className="header__btn">BOOK FREE TRIAL</a>
        </div>

        {/* Hamburger Menu Icon (Mobile Only) */}
        <button
          className={`header__hamburger ${isMobileMenuOpen ? 'header__hamburger--open' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          <span className="header__hamburger-bar"></span>
          <span className="header__hamburger-bar"></span>
          <span className="header__hamburger-bar"></span>
        </button>
      </div>

      {/* Mobile Drawer Navigation */}
      <div className={`header__mobile-drawer ${isMobileMenuOpen ? 'header__mobile-drawer--open' : ''}`}>
        <div className="header__mobile-overlay" onClick={toggleMobileMenu}></div>
        <div className="header__mobile-content">
          <div className="header__mobile-header">
            <div className="header__logo-container">
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/logo.png`}
                alt="Al Quran Lesson"
                className="header__logo-image"
              />
            </div>
          </div>
          <ul className="header__mobile-menu">
            <li>
              <a href="/" className={`header__mobile-link ${currentPath === '/' ? 'header__mobile-link--active' : ''}`} onClick={toggleMobileMenu}>HOME</a>
            </li>
            <li>
              <a href="/about-us/" className={`header__mobile-link ${currentPath === '/about-us' ? 'header__mobile-link--active' : ''}`} onClick={toggleMobileMenu}>ABOUT US</a>
            </li>

            {/* Courses Mobile Dropdown */}
            <li>
              <button
                className={`header__mobile-link-btn ${activeMobileDropdown === 'courses' ? 'header__mobile-link-btn--open' : ''}`}
                onClick={() => handleMobileDropdownToggle('courses')}
              >
                COURSES
                <svg className="header__chevron" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
                </svg>
              </button>
              <ul className={`header__mobile-submenu ${activeMobileDropdown === 'courses' ? 'header__mobile-submenu--open' : ''}`}>
                <li><a href="/noorani-qaida-course/" onClick={toggleMobileMenu}>Noorani Qaida</a></li>
                <li><a href="/quran-reading-classes-online-for-kids-and-adults/" onClick={toggleMobileMenu}>Quran Reading Classes Online</a></li>
                <li><a href="/online-tajweed-classes-tajweed-course/" onClick={toggleMobileMenu}>Quran Tajweed Classes</a></li>
                <li><a href="/quran-memorization-classes-course/" onClick={toggleMobileMenu}>Quran Memorization Classes</a></li>
                <li><a href="/quran-translation-classes/" onClick={toggleMobileMenu}>Quran Translation Classes Online</a></li>
              </ul>
            </li>

            <li>
              <a href="/quran-classes-fee/" className={`header__mobile-link ${currentPath === '/quran-classes-fee' ? 'header__mobile-link--active' : ''}`} onClick={toggleMobileMenu}>FEE PACKAGES</a>
            </li>
            <li>
              <a href="/blog/" className={`header__mobile-link ${currentPath === '/blog' ? 'header__mobile-link--active' : ''}`} onClick={toggleMobileMenu}>BLOG</a>
            </li>

            {/* Locations Mobile Dropdown */}
            <li>
              <div className="header__mobile-link-wrapper">
                <a href="/locations/" className={`header__mobile-link ${currentPath === '/locations' ? 'header__mobile-link--active' : ''}`} onClick={toggleMobileMenu}>LOCATIONS</a>
                <button
                  className={`header__mobile-dropdown-toggle ${activeMobileDropdown === 'locations' ? 'header__mobile-dropdown-toggle--open' : ''}`}
                  onClick={() => handleMobileDropdownToggle('locations')}
                  aria-label="Toggle locations dropdown"
                >
                  <svg className="header__chevron" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
                  </svg>
                </button>
              </div>
              <ul className={`header__mobile-submenu ${activeMobileDropdown === 'locations' ? 'header__mobile-submenu--open' : ''}`}>
                <li><a href="/online-quran-classes-in-newyork/" onClick={toggleMobileMenu}>Online Quran Classes In NewYork</a></li>
                <li><a href="/online-quran-classes-canada/" onClick={toggleMobileMenu}>Online Quran Classes In Canada</a></li>
                <li><a href="/online-quran-classes-texas/" onClick={toggleMobileMenu}>Online Quran Classes In Texas</a></li>
                <li><a href="/online-quran-classes-california/" onClick={toggleMobileMenu}>Online Quran Classes In California</a></li>
                <li><a href="/florida-online-quran-classes/" onClick={toggleMobileMenu}>Online Quran Classes In Florida</a></li>
              </ul>
            </li>

            {/* Our Tutors Mobile Dropdown */}
            <li>
              <div className="header__mobile-link-wrapper">
                <a href="/our-tutors/" className={`header__mobile-link ${currentPath === '/our-tutors' ? 'header__mobile-link--active' : ''}`} onClick={toggleMobileMenu}>OUR TUTORS</a>
                <button
                  className={`header__mobile-dropdown-toggle ${activeMobileDropdown === 'tutors' ? 'header__mobile-dropdown-toggle--open' : ''}`}
                  onClick={() => handleMobileDropdownToggle('tutors')}
                  aria-label="Toggle tutors dropdown"
                >
                  <svg className="header__chevron" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
                  </svg>
                </button>
              </div>
              <ul className={`header__mobile-submenu ${activeMobileDropdown === 'tutors' ? 'header__mobile-submenu--open' : ''}`}>
                <li>
                  <div className="header__mobile-link-wrapper header__mobile-link-wrapper--nested">
                    <a href="/our-tutors/#male-tutors" className="header__mobile-link header__mobile-link--nested" onClick={toggleMobileMenu}>Male Tutors</a>
                    <button
                      className={`header__mobile-dropdown-toggle header__mobile-dropdown-toggle--nested ${isMobileMaleTutorsOpen ? 'header__mobile-dropdown-toggle--open' : ''}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        setIsMobileMaleTutorsOpen(!isMobileMaleTutorsOpen);
                      }}
                      aria-label="Toggle male tutors dropdown"
                    >
                      <svg className="header__chevron" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
                      </svg>
                    </button>
                  </div>
                  <ul className={`header__mobile-nested-submenu ${isMobileMaleTutorsOpen ? 'header__mobile-nested-submenu--open' : ''}`}>
                    <li><a href="/our-tutors/molana-hafiz-kaleem-ullah/" onClick={toggleMobileMenu}>Molana Hafiz Kaleem Ullah</a></li>
                    <li><a href="/our-tutors/molana-hafiz-qari-osama-hussein/" onClick={toggleMobileMenu}>Molana Hafiz Qari Osama Hussein</a></li>
                  </ul>
                </li>
                <li>
                  <div className="header__mobile-link-wrapper header__mobile-link-wrapper--nested">
                    <a href="/our-tutors/#female-tutors" className="header__mobile-link header__mobile-link--nested" onClick={toggleMobileMenu}>Female Tutors</a>
                    <button
                      className={`header__mobile-dropdown-toggle header__mobile-dropdown-toggle--nested ${isMobileFemaleTutorsOpen ? 'header__mobile-dropdown-toggle--open' : ''}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        setIsMobileFemaleTutorsOpen(!isMobileFemaleTutorsOpen);
                      }}
                      aria-label="Toggle female tutors dropdown"
                    >
                      <svg className="header__chevron" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
                      </svg>
                    </button>
                  </div>
                  <ul className={`header__mobile-nested-submenu ${isMobileFemaleTutorsOpen ? 'header__mobile-nested-submenu--open' : ''}`}>
                    <li><a href="/our-tutors/qaria-sadaf-sarfaraz/" onClick={toggleMobileMenu}>Qaria Sadaf Sarfaraz</a></li>
                    <li><a href="/our-tutors/aalima-qaria-yousra/" onClick={toggleMobileMenu}>Aalima Qaria Yousra</a></li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
          <div className="header__mobile-cta">
            <a href="/free-trial/" className="header__btn header__btn--mobile" onClick={toggleMobileMenu}>BOOK FREE TRIAL</a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;

